export class ConsentComplete {
  studentId: number | string;
  envelopeId: string;
  consentId: number | string;
  consentIds: number[];
  studentConsentId: number | string;
  locationId: number;
}
